const recent = (state = [], action) => {
  switch (action.type) {
    case 'SET_RECENT_CALLS':
      return action.payload;
    default:
      return state;
  }
};

export default recent;
